<!-- 大修养护材料选择表-->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form popoverWidth="680" :formConfig="advSearch" v-model="searchForm" @onSubmit="searchTable"></popover-form>
        </el-col>
        <el-col :span="20">
            <div class="text-align_right">
                <el-button type="primary" @click="addRow">新增</el-button>
            </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="goPageIndex"
          :pageCount="pageCount"
          @rowClick="rowClick($event)"
        ></dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
              <el-button-group>
                <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="dataSubmit" >保存</el-button>
                <el-button type="primary" @click="close">返回</el-button>
              </el-button-group>
          </div>
          <divider title="结构性修复材料选择表详细" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="!(operationType==1||operationType==2)" v-model="form"></dynamic-form>
          <el-dialog :visible.sync="dialogMaintainVisible" width="80%" custom-class="dialogStyle">
              <bdStructureMaterialTable class="dialog-top" :tableUse="tableUseMaintain"></bdStructureMaterialTable>
          </el-dialog>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
      <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<script>
import bdStructureMaterialTable from '@/views/basic/roadProduction/bdStructureMaterialTable'
export default {
  name: "overhaulmaterials",
  //import引入的组件需要注入到对象中才能使用
  components: {bdStructureMaterialTable},
  data() {
    return {
      initializeForm:{},
      showTabFom: false, //表格表单转换状态
      operationType: 1, //主表操作状态

      dialogMaintainVisible:false,
      tableUseMaintain: {
        show: true,
        size: "mini",
        type: "success",
        plain: true,
        round: false,
        circle: false,
        loading: false,
        disabled: false,
        icon: "",
        title: "使用",
        name: "使用",
        horizon:'',
        click: this.useMaintain
      },

      searchForm: {
        highwayLevel :'',/// 适用公路等级
        surfaceType :'',/// 面层类型
      },
      advSearch: {
        list: [
            {
                "type": "select",
                "icon": "icon-select",
                "options": {
                  "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": false,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
                  "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "name","label": "name"},"remoteFunc": this.getDiction,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
                },
                "name": "适用公路等级",
                "key": "公路等级",
                "model": "highwayLevel",
                "rules": [{required: false,message: "必须填写"}]
            }, {
                "type": "select",
                "icon": "icon-select",
                "options": {
                    "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择",
                    "required": false,"requiredMessage": "","showLabel": false,"width": "",
                    "options": [{"label":"沥青路面"},{"label":"水泥路面"},{"label":"砂石路面"}],
                    "remote": false,"remoteType": "option","remoteOption": "option_1593590909123","filterable": false,
                    "remoteOptions": [],"props": {"value": "label","label": "label"},"remoteFunc": "func_1593590909123",
                    "customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true
                },
                "name": "面层类型",
                "key": "surfaceType",
                "model": "surfaceType",
                "rules": []
            }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      tableSet: {
        tableColumn: [
          {
            prop: "surfaceType",
            label: "面层类型"
          },{
            prop: "highwayLevel",
            label: "适用公路等级"
          },{
            prop: "compareSymbols",
            label: "对比符号"
          },{
            prop: "pci",
            label: "PCI值"
          },{
            prop: "material",
            label: "养护材料"
          },{
            prop: "stockThickness",
            label: "材料厚度(cm)"
          },{
            prop: "remark",
            label: "备注"
          }
        ],
        tableColBtn: [
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
          show: true,
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.del
        }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      form: {
        rowCode :0,/// 主键  int
        highwayLevel :[],/// 适用公路等级
        surfaceType :[],/// 面层类型
        pci :0,/// PCI值   decimal
        compareSymbols :'',/// 对比符号
        material :'',/// 养护材料
        stockThickness :0,/// 材料厚度    decimal
        remark :'',
        createUser :'',
        createUserName :'',
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        status :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
      },
      formConfig: {
        list: [
            {
                "type": "select",
                "icon": "icon-select",
                "options": {
                  "defaultValue": "","multiple": true,"disabled": false,"clearable": false,"placeholder": "请选择","required": true,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
                  "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "name","label": "name"},"remoteFunc": this.getDiction,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
                },
                "name": "适用公路等级",
                "key": "公路等级",
                "model": "highwayLevel",
                "rules": [{required: true,message: "必须填写"}]
            }, {
                "type": "select",
                "icon": "icon-select",
                "options": {
                    "defaultValue": "","multiple": true,"disabled": false,"clearable": false,"placeholder": "请选择",
                    "required": false,"requiredMessage": "","showLabel": false,"width": "",
                    "options": [{"label":"沥青路面"},{"label":"水泥路面"},{"label":"砂石路面"}],
                    "remote": false,"remoteType": "option","remoteOption": "option_1593590909123","filterable": false,
                    "remoteOptions": [],"props": {"value": "label","label": "label"},"remoteFunc": "func_1593590909123",
                    "customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true
                },
                "name": "面层类型",
                "key": "surfaceType",
                "model": "surfaceType",
                "rules": [{required: false,message: "必须填写"}]
            }, {
                "type": "input",
                "icon": "icon-input",
                "options": {
                    "width": "100%",
                    "defaultValue": "",
                    "required": true,
                    "dataType": "string",
                    "pattern": "",
                    "placeholder": "",
                    "disabled": false,
                    "remoteFunc": "func_1590919288000_36490"
                },
                "name": "对比符号",
                "key": "compareSymbols",
                "model": "compareSymbols",
                "rules": [{required: true,message: "必须填写"},{"type": "string", "message": "规划批次名称格式不正确"}]
            }, {
                type: "number",
                icon: "icon-number",
                options: {
                  width: "",required: true,defaultValue: 0,min: 0,max: 999999999,step: 0.001,disabled: false,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
                },
                name: "PCI值",
                novalid: {},
                key: "pci",
                model: "pci",
                rules: [{required: true,message: "必须填写"}]
            }, {
                "type": "input",
                "icon": "icon-input",
                "options": {
                    "width": "100%",
                    "defaultValue": "",
                    "required": true,
                    "dataType": "string",
                    "pattern": "",
                    "placeholder": "请选择养护材料",
                    "disabled": false,
                    "remoteFunc": "func_1590919288000_36490",
                    onFocus: this.getMaintain
                },
                "name": "养护材料",
                "key": "material",
                "model": "material",
                "rules": [{"type": "string", "message": "中面层材料格式不正确"}, {
                    "required": true,
                    "message": "养护材料必须填写"
                }]
            }, {
                type: "number",
                icon: "icon-number",
                options: {
                  width: "",required: false,defaultValue: 0,min: 0,max: 999999999,step: 0.01,disabled: false,controlsPosition: "",customClass: "",labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,remoteFunc: "func_1573045175616"
                },
                name: "材料厚度(cm)",
                novalid: {},
                key: "stockThickness",
                model: "stockThickness",
                rules: [{required: false,message: "必须填写"}]
            }, {
                "type": "textarea",
                "icon": "icon-diy-com-textarea",
                "options": {
                  "width": "500px","defaultValue": "","required": false,"disabled": false,"pattern": "","placeholder": "","customClass": "",
                  "labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteFunc": "func_1577068006527","remoteOption": "option_1577068006527"
                },
                "name": "备注",
                "key": "1577068006527",
                "model": "remark",
                "rules": []
            }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    setMultiple(row){
      if (row.highwayLevel) {
        if(row.highwayLevel.indexOf(',')>=0){this.form.highwayLevel = row.highwayLevel.split(",")
        }else if(row.highwayLevel.indexOf('，')>=0){this.form.highwayLevel = row.highwayLevel.split("，")
        }else{this.form.highwayLevel = [row.highwayLevel];}
      }else{ this.form.highwayLevel = []; }
      if (row.surfaceType) {
        if(row.surfaceType.indexOf(',')>=0){this.form.surfaceType = row.surfaceType.split(",")
        }else if(row.surfaceType.indexOf('，')>=0){this.form.surfaceType = row.surfaceType.split("，")
        }else{this.form.surfaceType = [row.surfaceType];}
      }else{ this.form.surfaceType = []; }
    },
    /********字典获取 ******/
    getDiction(target, targets) {
        let name = target.form.key;
        this.$http.post(this.$url.getDict, { search: name }).then(res => {
            let { data } = res;
            target.setList(data);
        });
    },
    getMaintain(){
        this.dialogMaintainVisible = true;
    },
    useMaintain(row,index) {
        this.form.material=row.materialName;
        this.dialogMaintainVisible = false;
    },
    /*******获取表格数据*****/
    getTableData() {
        let that = this;
        this.$http.postHandle('',this.$url.routeDecision.getoverhaulmaterials, { ...that.searchForm, pageIndex:this.pageIndex, pageSize:this.pageSize }).then(res => {
            this.tableData = res.data;
            this.pageCount = res.pageCount;
        });
    },
    addRow() {//新增
      this.showTabFom = true;
      this.operationType = 1;
      this.resetForm("form");
    },
    searchTable(){//查询
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    goPageIndex(pageIndex,pageSize) {//分页
      this.pageIndex = pageIndex;
      this.pageSize = pageSize
      this.getTableData();
    },
    rowClick(row) {//查看
        this.operationType = 3;
        this.form = this.$formSetForm(this.form,row);
        this.setMultiple(row);
        this.showTabFom = true;
    },
    edit(row, index) {//编辑
        this.operationType = 2;
        this.form = this.$formSetForm(this.form,row);
        this.setMultiple(row);
        this.showTabFom = true;
    },
    del(row, index) {//删除
      let form = row;
      this.$msgDel(this.$url.routeDecision.operationoverhaulmaterial, { overhaulMaterial: form, operationType: 8 }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.getTableData();
      });
    },
    dataSubmit() {//保存
        this.$refs.form.submit().then(res => {
            let form = this.$formSetForm(this.form, this.form);
            form.highwayLevel = this.form.highwayLevel.join(",");
            form.surfaceType = this.form.surfaceType.join(",");
            this.$http.postHandle("保存", this.$url.routeDecision.operationoverhaulmaterial, { overhaulMaterial: form, operationType: this.operationType }).then(res => {
                this.showTabFom = false;
                this.getTableData();
            });
        });
    },
    close() {//返回
      this.$closePage(this.operationType).then(() => {
        this.showTabFom = false;
        this.getTableData();
      });
    },
    resetForm(formName) {//重置
      let that = this;
      this.form = this.$formSetForm(this.initializeForm , this.initializeForm)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTableData();
    this.initializeForm = this.$formSetForm(this.form , this.form)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/OverhaulMaintenanceDic/overhaulmaterials.vue"
}
</vue-filename-injector>
